import { Outlet } from 'react-router-dom';
import { useContext } from 'react';
import AppContext from "../../context";
import Meta from "../components/Meta";

import styles from '../../styles/GiftVouchers.module.scss'

function GiftVouchersTemplate() {
    const context = useContext(AppContext);
    return (
        <>
            <Meta title="Gift Vouchers" />
            <main className={styles.giftVouchers}>
                <div>
                    <div className={styles.header}>
                        <img src={context.domain.logo || `https://surecode.fra1.cdn.digitaloceanspaces.com/${context.domain._id}/logo.svg`} alt={context.domain.name} />
                        <h1>Gift Vouchers</h1>
                    </div>
                    <Outlet />
                    <div className={styles.footer}>
                        <a href={context.domain?.base || "/"}>Exit to Main Website</a>
                    </div>
                </div>
                <span />
            </main>
        </>
    );
}

export default GiftVouchersTemplate
